import CheckoutPage from "@/features/checkout/containers/checkout-page";
import { createFileRoute } from "@tanstack/react-router";

// Canonical path: /checkout
export const Route = createFileRoute("/checkout/")({
  component: CheckoutPage,
});
